import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import "../../assets/libs/node-waves/waves.min.css";
import { Link } from "react-router-dom";
import axios from "axios";
import Spinner from "../Spinner/spinner";
import Cookies from "js-cookie";
import api from "../../api";


const baseUrl = process.env.REACT_APP_BASE_URL;
const columns = (languageData, cookieLang) => [
  {
    name: languageData.table.ref,
    selector: (row) => row.reference,
    sortable: true,
  },
  {
    name: languageData.table.type,
    selector: (row) => row.type,
    sortable: true,
  },
  {
    name: languageData.table.amount,
    selector: (row) => `${row.currency} ${parseFloat(row.amount)}`,
    sortable: true,
  },
  {
    name: languageData.table.method,
    selector: (row) => row.method,
    sortable: true,
  },
  {
    name: languageData.table.status,
    selector: (row) => row.status,
    sortable: true,
    cell: (row) => {
      let badgeClass = "secondary-bd";
      if (row.status === "Paid") {
        badgeClass = "success";
      } else if (row.status === "Failed") {
        badgeClass = "danger";
      }

      return (
        <span className={`badge rounded-pill bg-${badgeClass}`}>
          {languageData.status[row.status.toLowerCase()] || row.status}
        </span>
      );
    },
  },

  {
    name: languageData.table.date,
    selector: (row) => row.date.toString(),
    sortable: true,
    cell: (row) => {
      const dateTime = new Date(row.date);
      let formattedDate;

      if (cookieLang === "en") {
        const year = dateTime.getFullYear();
        const month = String(dateTime.getMonth() + 1).padStart(2, "0");
        const day = String(dateTime.getDate()).padStart(2, "0");
        const hours = String(dateTime.getHours()).padStart(2, "0");
        const minutes = String(dateTime.getMinutes()).padStart(2, "0");
        formattedDate = `${year}-${month}-${day} ${hours}:${minutes}`;
      } else {
        formattedDate = new Intl.DateTimeFormat("fr-FR", {
          timeZone: "UTC",
           year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        }).format(dateTime);
      }

      return <span>{formattedDate}</span>;
    },
  },
  {
    name: languageData.table.receipt,
    selector: (row) => row.receipt,
    sortable: true,
    cell: (row) =>
      row.status === "Paid" ? (
        <button data-interaction="view_receipt_button"
          className="btn btn-primaryy fs-12 view_receipt_button"
        >
         {languageData.view}
        </button>
      ) : null,
  },

  {
    name: languageData.table.details,
    selector: (row) => row.details,
    sortable: true,
    cell: (row) => {
      if (row.status === "Paid") {
        return <span></span>;
      } else if (row.status === "Failed") {
        return <span>{row.details.message}</span>;
      }
    },
  },
];

const customStyles = {
  table: {
    style: {
      border: "1px solid #dee2e6",
    },
  },
  headRow: {
    style: {
      background: "#edeef1",
      fontWeight: "400",
      textAlign: "center",
      fontSize: "13px",
    },
  },
  cells: {
    style: {
      textAlign: "start",
    },
  },
};

const Tabpayment = () => {
  const [languageData, setLanguageData] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [cookieLang, setCookieLang] = useState("en");
  const [showSpinner, setShowSpinner] = useState(false);

  const [paymentData, setPaymentData] = useState({
    total: 0,
    data: [],
  });

  const fetchData = async () => {
    try {
        setShowSpinner(true);
        const response = await api.get(
      `/invoicing/payments/list`);
      const resp = {
        ok: true,
         data: response.data,
      };
      if (!resp.ok) {
        throw new Error(resp.status);
      }
      const res = {
      total: resp.data.data.length,
      data: resp.data.data,
      };
      setPaymentData(res);
    } catch (error) {}
    finally {
        setShowSpinner(false);
    }
  };

  useEffect(() => {
       const defaultLang = process.env.REACT_APP_LANG;
 const lang = localStorage.getItem("lang") ||
  document.cookie
    .split("; ")
    .find((row) => row.startsWith("lang="))
    ?.split("=")[1] ||
  defaultLang;

    if (lang) {
      setCookieLang(lang);
      import(`../../lang/payments/${lang}.json`)
        .then((data) => {
          setLanguageData(data);
        })
        .catch((error) => {
          console.error("Error loading language file:", error);
        });
    } else {
      console.warn("Language cookie 'lang' not found.");
    }
    fetchData()
  }, []);

  if (!languageData) {
    return <div></div>;
  }

  const filteredData = paymentData.data.filter((row) =>
    row.reference.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="">
      <div className="col-xl-12">
        <div className="card custom-card">
          <div className="card-header d-flex align-items-center justify-content-between gap-2">
            <div className="card-title">{languageData.title}</div>
            <div className="card-actions">
              <Link to={`/plans`} className="btn btn-primary">
                {languageData.primary_btn}
              </Link>
            </div>
          </div>
          <div className="card-body">
            <div
              id="datatable-basic_wrapper"
              className="dataTables_wrapper dt-bootstrap5 no-footer"
            >
              {filteredData.length !== 0 && (
              <div className="row mb-3" style={{ width: "102%" }}>
                <div className="col-sm-12 col-md-6 ms-auto d-flex justify-content-end">
                  <label className="d-inline-flex align-items-center">
                    <input
                    name="search"
                      type="search"
                      className="form-control form-control-sm"
                      placeholder={languageData.table.search}
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                    />
                  </label>
                </div>
              </div>
              )}

                     {showSpinner ? (
  <Spinner />
) :filteredData.length === 0 ? (
                <div
                  className="no-results d-flex flex-column justify-content-center align-items-center text-center"
                  style={{ minHeight: "200px" }}
                >
                  <i
                    className="bx bx-money"
                    style={{ fontSize: "40px", color: "grey" }}
                  ></i>
                  <div>
                    <h3 className="text-muted">
                      {languageData?.no_appointment }
                    </h3>
                    <p className="text-muted">
                     {languageData?.no_appointment_description }
                    </p>
                  </div>
                </div>
              ) : (
                <DataTable
                  columns={columns(languageData, cookieLang)}
                  data={filteredData}
                  customStyles={customStyles}
                  pagination
                  paginationComponentOptions={{
                    rowsPerPageText: languageData.table.row,
                    rangeSeparatorText: "of",
                  }}
                  highlightOnHover
                  pointerOnHover
                  sortServer
                  defaultSortField="id"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Tabpayment;
